import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { WFPButton } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

// Shown when a signed-in user has no Farm2Go access.
export const LoginForbiddenGuest = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-6 text-foreground">
      <Card className="w-full max-w-md text-center shadow-md">
        <CardHeader className="flex flex-col items-center gap-4">
          <span className="flex size-16 items-center justify-center rounded-full bg-danger-100 text-danger-600">
            <ShieldAlert className="size-8" aria-hidden="true" />
          </span>
          <CardTitle className="text-2xl">{t("loginForbidden.guestNoAccessTitle")}</CardTitle>
          <CardDescription className="text-base">
            {t("loginForbidden.guestNoAccessBody")} {t("loginForbidden.guestNoAccessContact")}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <WFPButton type="button" onClick={() => history.push("/logout")}>
            {t("loginForbidden.backToLoginPage")}
          </WFPButton>
        </CardContent>
      </Card>
    </div>
  );
};
